<div class="calendar-month-view-mini">
    <mwl-calendar-month-view
        #monthView
        [viewDate]="viewDate"
        [events]="events"
        [locale]="locale"
        (dayClicked)="dayClicked($event)"
        [headerTemplate]="headerTemplate"
        [cellTemplate]="customCellMonthTemplate">
    </mwl-calendar-month-view>  
    
    <div class="calendar-list-container">
        <sgt-calendar-list
            [viewDate]="viewDate"
            [events]="eventsList"
            [eventTemplate]="eventTemplate"
            (eventClicked)="eventClicked.emit($event)">
        </sgt-calendar-list>
    </div>
</div>

<ng-template
    #headerTemplate
    let-days="days"
    let-locale="locale">
    <div class="cal-cell-row cal-header">
        <div
            class="cal-cell"
            *ngFor="let day of days; trackBy:trackByWeekDayHeaderDate"
            [class.cal-past]="day.isPast"
            [class.cal-today]="day.isToday"
            [class.cal-future]="day.isFuture"
            [class.cal-weekend]="day.isWeekend"
            [ngClass]="day.cssClass">
            {{ day.date | date :'EEE':'':locale}}
        </div>
    </div>
</ng-template>

<ng-template
	#customCellMonthTemplate
	let-day="day"
	let-openDay="openDay"
	let-locale="locale"
	let-tooltipPlacement="tooltipPlacement"
	let-highlightDay="highlightDay"
	let-unhighlightDay="unhighlightDay"
	let-eventClicked="eventClicked"
	let-tooltipTemplate="tooltipTemplate"
	let-tooltipAppendToBody="tooltipAppendToBody">

	<div class="cal-day" [ngClass]="{'cal-day-active': day === activeDay}">
		<div class="cal-cell-top">
			<span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
		</div>
		<div class="cal-events" *ngIf="day.events?.length > 0">

			<div class="cal-event-container"
				*ngFor="let event of day.events | calendarEventsLimitFilter: (day.meta ? day.meta.limitEventsShowing : 3); trackBy:trackByEventId">
                <div class="cal-event"
                    [ngStyle]="{'background-color': event.color?.primary}">
                </div>
			</div>
		</div>
	</div>
</ng-template>